<template>
    <div class="mdc-dialog darkModeModal" data-mdc-auto-init="MDCDialog" style="display: block;">
        <div class="mdc-dialog__container"
            style="opacity:1; transform: scale(1);padding-bottom: 150px;">
            <div class="mdc-dialog__surface" role="alertdialog" aria-modal="true"
                aria-labelledby="my-dialog-title" aria-describedby="my-dialog-content"
                style="max-width: calc(100vw - 80px)">
                <div class="pdl-24 pdr-24 pdt-3 pdb-3 d-flex">
                    <i class="material-icons t-color-whiteHigh visibility-h mdc-icon-button" @click="closeResource" @keypress="closeResource" tabindex="0" >close</i>
                    <div class="t-color-whiteHigh t-subtitle4  font-r t-center flex-grow-1 d-flex justify-content-center align-items-center">
                        {{$t('1081')}}
                    </div>
                    <i class="material-icons t-color-whiteHigh mdc-icon-button" @click="closeResource()" @keypress="closeResource()" tabindex="0" >close</i>
                </div>
                <div class="divider-white"></div>
                <div class="mdc-dialog__content pda-24" id="my-dialog-content">
                    <section id="quizDetailContents" class="t-color-whiteHigh" v-html="currentTimelineContents.text" ></section>
                    <!-- <img src="images/resourse-thumbnail.PNG" alt=""> -->
                </div>
            </div>
        </div>
        <div class="mdc-dialog__scrim" style="opacity:1;"></div>
    </div>
   
</template>

<script>
/**
 * 나의 학습 차시 학습창 - 타임라인 리소스 컨텐츠 컴포넌트(my learning lesson study - timeline resource contents component)
 *
 * @author minkyoung.park@emcast.com
 */
import {MDCRipple} from '@material/ripple'
// Components/Mixin/Extend/API define
function isPortrait() {
    if (screen.orientation === undefined) {
        return window.orientation === 0 || window.orientation === 180;
    } else {
        return screen.orientation.angle === 0;
    }
}
    
export default {
    props: ['currentTimelineContents'],
    data() {
        return {
            isPortrait: isPortrait()
        }
    },
     watch: {
        currentTimelineContents(){
            document.getElementsByTagName("img").removeAttribute("style"); 
        }
    },
    mounted() {
        // 화면 회전 이벤트가 발생했을 경우(When a screen rotation event)
        this.setMaterialUi()
        window.addEventListener('orientationchange', (aaa) => {
            this.isPortrait = isPortrait()
            if (!this.isPortrait) {
                this.openResource()
            }
        })

        // 처음 실행될 경우 가로 세로 모드 체크(When running for the first time, check the portrait mode)
        if (!this.isPortrait) {
            this.openResource()
        }

        setTimeout(()=>{
            document.querySelector("#quizDetailContents p img").removeAttribute("style")
            //document.querySelector("#quizDetailContents p img").style= "";
            document.querySelector("#quizDetailContents p img").style.width = "100%";
            //document.querySelector("#quizDetailContents p img").style.height = "100%";
            document.querySelector("#quizDetailContents p img").style.objectFit  = "contain";
        },500)
    },
    
    methods: {
        // 닫기(close)
        closeResource() {
            this.$emit('closeResource')
        },

        // 열기(open)
        openResource() {
            this.$emit('openResource')
        },
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    }
}
</script>
<style scoped>
@media (orientation: landscape){
#studyContainer #quizDetailContainer {
    width: calc(50% - 4px);
    position: relative;
    background-color: var(--ContentBG);
    background: var(--ContentBG);
    color: var(--DocumentWhite);
    width: 100% !important;
    left: 0;
    position: absolute !important;
    z-index: 999;
    margin: 0 auto;
    height: 100%;
}
html[dir="rtl"] #studyContainer #quizDetailContainer {
    right: 0;
}
#studyContainer #quizDetailContainer header, #studyContainer #quizDetailContainer header .mdc-top-app-bar__navigation-icon {
    color: var(--Primary) !important;
    color: var(--WhiteHigh) !important;
}
#studyContainer #quizDetailContainer header, #studyContainer #quizDetailContainer header .mdc-top-app-bar__navigation-icon {
    background-color: transparent  !important;
}
section#quizDetailContents p img {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
}
}
section#quizDetailContents p img {
    height: 229px !important;
}
section#quizDetailContents p:not(:first-child) {
    margin-bottom: 0;
    height: 229px;
}
.mdc-dialog__surface {
    min-width: 460px !important;
    max-width: 460px !important;
    height: 332px;
}
</style>